import { useState, useEffect, useContext, useRef } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Magic } from "magic-sdk";
import { ethers } from "ethers";
import { useNavigate } from "react-router-dom";
import abi from "../contracts/abi.json";

import {
  Chart as ChartJS,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend,
} from "chart.js";

import { Radar } from "react-chartjs-2";
import axios from "axios";
import { UserContext } from "../lib/UserContext";

ChartJS.register(
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend
);

interface ChartInstance {
  toBase64Image: () => string;
}

const Glyph = () => {
  const navigate = useNavigate();
  const loginAccountUsername = localStorage.getItem("accountUsername");

  const [user, setUser] = useContext(UserContext);
  const [resUrl, setResUrl] = useState("");
  
  useEffect(() => {
     user && !user.userId && !user.userName && navigate("/login");
  }, [user, navigate]);

  const chartRef = useRef(null);

  const question_id = localStorage.getItem("question_id");

  const [purpose, setPurpose] = useState(parseFloat(localStorage.getItem("purpose")).toFixed(1));
  const [connectivity, setConnectivity] = useState(
    parseFloat(localStorage.getItem("connectivity")).toFixed(1)
  );
  const [transparency, setTransparency] = useState(
    parseFloat(localStorage.getItem("transparency")).toFixed(1)
  );
  const [efficiency, setEfficiency] = useState(
    parseFloat(localStorage.getItem("efficiency")).toFixed(1)
  );
  const [impact, setImpact] = useState(parseFloat(localStorage.getItem("impact")).toFixed(1));
  const [profitability, setProfitability] = useState(
    parseFloat(localStorage.getItem("profitability")).toFixed(1)
  );
  const [mutualism, setMutualism] = useState(parseFloat(localStorage.getItem("mutualism")).toFixed(1));
  const [individualism, setIndividualism] = useState(
    parseFloat(localStorage.getItem("individualism")).toFixed(1)
  );

  const dataDark = {
    labels: [
      "Mutualism",
      "Efficiency",
      "Impact",
      "Purpose",
      "Individualism",
      "Transparency",
      "Profit",
      "Connectivity",
    ],
    datasets: [
      {
        data: [
          mutualism,
          efficiency,
          impact,
          purpose,
          individualism,
          transparency,
          profitability,
          connectivity,
        ],
        backgroundColor: "rgba(169, 223, 225, 0.5)",
        borderColor: "rgba(169, 223, 225, 1)",
        pointRadius: 0,
        fill: true,
        borderWidth: 2,
      },
    ],
  };

  const optionsDark = {
    plugins: {
      legend: {
        display: false,
      },
      customCanvasBackgroundColor: {
        color: "black",
      },
    },
    scales: {
      r: {
        angleLines: {
          display: false,
        },
        ticks: {
          display: false,
        },
        grid: {
          color: "rgba(108, 109, 113, 1)",
        },
        pointLabels: {
          color: "rgba(255, 255, 255, 1)",
        },

        suggestedMin: 0,
        suggestedMax: 10,
        backgroundColor: "rgba(50, 50, 50, 1)",
      },
    },
  };


  const handleDownloadClick = async () => {
    const question_id = localStorage.getItem("question_id");
    const chartInstance:any = chartRef.current;
    if (!chartInstance) return;
    const base64Image = chartInstance.toBase64Image("image/png", 1);
    const downloadLink = document.createElement("a");
    downloadLink.href = base64Image;
    downloadLink.download = "chart.png";
    downloadLink.click();
  };

  const uploadImage = async () => {
    const chartInstance:any = await chartRef.current;
    const chartBase64Image = await chartInstance.toBase64Image("image/png", 1);
    const blob1 = await fetch(chartBase64Image).then((res) => res.blob());
    const formData1 = await new FormData();
    await formData1.append("file", blob1, "chart.png");
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_SERVER_URL}/image`,
        formData1,
        {
          headers: {
            'accept': 'application/json',
            'Accept-Language': 'en-US,en;q=0.8',
            'Content-Type': `multipart/form-data; boundary=${formData1}`,
          },
          params: {
            question_id: question_id,
          },
        }
      );
      setResUrl(response.data.data.imageUrl);
      return response.data.data.imageUrl;
    } catch (error) {
      console.error("Upload error:", error);
    }
  };

  const handleJSONsubmission = async () => {
    const serverImageURL =await uploadImage();
    console.log("imageurl",serverImageURL);

    await axios({
      method: "post",
      url: process.env.REACT_APP_PINATA_URL,
      data: {
        name: "Dave Starbelly",
        description:
          "Friendly OpenSea Creature that enjoys long swims in the ocean.",
        image: serverImageURL,
        attributes: [
          {
            trait_type: "Mutualism",
            value: mutualism,
          },
          {
            trait_type: "Efficiency",
            value: efficiency,
          },
          {
            trait_type: "Impact",
            value: impact,
          },
          {
            trait_type: "Purpose",
            value: purpose,
          },
          {
            trait_type: "Individualism",
            value: individualism,
          },
          {
            trait_type: "Transparency",
            value: transparency,
          },
          {
            trait_type: "Profitability",
            value: profitability,
          },
          {
            trait_type: "Connectivity",
            value: connectivity,
          },
        ],
      },
      headers: {
        pinata_api_key: `5d84861fe44c09daaab5`,
        pinata_secret_api_key: `caf6aed134e58581ee9bff08d9bec1ec9564125d131802ad3a9bba663d75ab8a`,
        "Content-Type": "application/json",
      },
    }).then((res) => {
      mintFunction("https://ipfs.moralis.io:2053/ipfs/" + res?.data?.IpfsHash);
    });
  };

  const mintFunction = async (uri: any) => {
    const customNodeOptions = {
      rpcUrl: "https://rpc-mumbai.maticvigil.com/", // Polygon RPC URL
      chainId: 80001, // Polygon chain id
    };
    const magic:any = new Magic("pk_live_A84F2DB5369C3A06", {
      network: customNodeOptions,
    });
    magic.network = "matic";
    const provider = new ethers.providers.Web3Provider(magic.rpcProvider);
    const signer = await provider.getSigner();
    const address = await signer.getAddress();
    console.log("new address",address);

    let contract = new ethers.Contract(
      "0x7996d1D62661BE5815F60ce8A86c606D443d5806",
      abi,
      signer
    );

    toast.promise(
      contract
        .safeMint(uri, { value: ethers.utils.parseEther("0.01") })
        .then((transaction: any) => {
          toast.promise(
            transaction
              .wait()
              .then(async (tx: any) => {
                console.log("minted");
                await axios.put(
                  `${process.env.REACT_APP_SERVER_URL}/image`,
                  {
                    params: {
                      url: resUrl,
                    },
                  }
                );
              })
              .catch((err: any) => {
                alert("Error in Minting Token:" + err);
              }),
            {
              pending: "Minting in Process...",
              success: "Mint Successfully 👌",
              error: "Promise rejected 🤯",
            }
          );
        }).catch((err: any)=>{
          console.log("Error in Minting Token:" + err);
        }),
      {
        pending: "Waiting to Sign Transaction...",
        success: "Transaction Signed... 👌",
        error: "Transaction Rejected 🤯",
      }
    );
  };

  const logoutUser = () => {
    setUser({"userId":null, "userName":null, "magicLinkAccount":null})
  }

  return (
    <>
      <ToastContainer toastStyle={{ backgroundColor: "#000000" }} />
      <div className="bg-glayph h-screen font-inter">
        <div className="px-6 pt-6 lg:px-8">
          <nav className="flex items-center justify-between">
            <div className="flex lg:flex-1">
              <a href="" className="-m-1.5 p-1.5">
                <span className="sr-only">Celium</span>
                <img
                  className="h-14"
                  src={"image/celium-white.png"}
                  alt="celium-logo"
                />
              </a>
            </div>
              <div>
                <button onClick={() => navigate('/profile')} className="mr-5">Profile</button>
<button onClick={logoutUser}>Logout</button>
              </div>
          </nav>
        </div>
        <div className="container mx-auto">
          <div className="lg:flex flex-row gap-8">
            <div className="p-10 bg-black w-1/2">
              <Radar
                data={dataDark}
                options={optionsDark}
                ref={chartRef}
                id="MyChart"
              />
            </div>
            <div className="pt-10">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight text-purple-500 font-inter whitespace-nowrap">
                {user.userName} Glyph
              </h1>
              <p className="text-3xl pt-4">
                Congratulations! Here is your perspective of decentralization
                with value scores listed below.
              </p>
              <div className="grid grid-cols-1 md:grid-cols-2">
                <div>
                  <ul>
                    <li className="pt-3">
                      <span className="font-bold pr-10">Mutualism</span>
                      <span>{mutualism}</span>
                    </li>
                    <li className="pt-3">
                      <span className="font-bold pr-10">Efficiency</span>
                      <span>{efficiency}</span>
                    </li>
                    <li className="pt-3">
                      <span className="font-bold pr-10">Impact</span>
                      <span>{impact}</span>
                    </li>
                    <li className="pt-3">
                      <span className="font-bold pr-10">Purpose</span>
                      <span>{purpose}</span>
                    </li>
                    <li className="pt-3">
                      <span className="font-bold pr-10">Individualism</span>
                      <span>{individualism}</span>
                    </li>
                    <li className="pt-3">
                      <span className="font-bold pr-10">Transparency</span>
                      <span>{transparency}</span>
                    </li>
                    <li className="pt-3">
                      <span className="font-bold pr-10">Profit</span>
                      <span>{profitability}</span>
                    </li>
                    <li className="pt-3">
                      <span className="font-bold pr-10">Connectivity</span>
                      <span>{connectivity}</span>
                    </li>
                  </ul>
                </div>
                <div>
                  <button
                    className="bg-blue-400 hover:bg-purple-500 text-white font-bold py-2 px-10 focus:outline-none focus:shadow-outline rounded-3xl text-xl mt-12 mx-3"
                    onClick={handleDownloadClick}
                  >
                    Download Free Image
                  </button>
                  <button
                    className="bg-blue-400 hover:bg-purple-500 text-white font-bold py-2 px-10 focus:outline-none focus:shadow-outline rounded-3xl text-xl mt-12 mx-3"
                    onClick={handleJSONsubmission}
                  >
                    Mint as a Free NFT
                  </button>
                  <button
                    className="bg-blue-400 hover:bg-purple-500 text-white font-bold py-2 px-10 focus:outline-none focus:shadow-outline rounded-3xl text-xl mt-12 mx-3"
                    onClick={() => navigate('/premium-nft')}
                  >
                    View Premium NFTs
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Glyph;
